import { utils, writeFile } from 'xlsx';
import gql from 'graphql-tag';
import xaxios from '@/xaxios';

export const descargarExcel = (headers, datos, totales) => {
  const camposOrdenado = datos.map((item) => {
    const ordenado = {};
    headers.forEach((header) => {
      ordenado[header.value] = item[header.value];
    });

    return ordenado;
  });

  const totalesOrdenados = headers.reduce((obj, header) => {
    obj[header.value] = totales[header.value];
    return obj;
  }, {});
  totalesOrdenados['numero_documento'] = 'TOTALES';
  camposOrdenado.push(totalesOrdenados);

  let data = utils.json_to_sheet(camposOrdenado);
  const workbook = utils.book_new();
  const filename = 'reporte-titulaciones';
  utils.book_append_sheet(workbook, data, filename);
  writeFile(workbook, `${filename}.xlsx`);
};


export const descargarExcelSede = (headers, datos, totales) => {
  const camposOrdenado = datos.map((item) => {
    const ordenado = {};
    headers.forEach((header) => {
      ordenado[header.value] = item[header.value];
    });

    return ordenado;
  });

  const totalesOrdenados = headers.reduce((obj, header) => {
    obj[header.value] = totales[header.value];
    return obj;
  }, {});
  totalesOrdenados['nombre_compuesto'] = 'TOTALES';
  camposOrdenado.push(totalesOrdenados);

  let data = utils.json_to_sheet(camposOrdenado);
  const workbook = utils.book_new();
  const filename = 'reporte-titulaciones';
  utils.book_append_sheet(workbook, data, filename);
  writeFile(workbook, `${filename}.xlsx`);
};

export const getGestiones = async (vue) => {
  const res = await vue.$apollo
    .query({
      query: gql`
        query {
          getGestiones {
            gestion
          }
        }
      `,
    })
    .then(({ data: { getGestiones } }) => {
      return getGestiones.reverse();
    })
    .catch((error) => error);
  const ges = [];
  res.forEach((g) => ges.push(g.gestion));
  return ges;
};

export const getProgramas = async (vue, idsede, iduniversidad, gestion) => {
  const res = await vue.$apollo
    .query({
      query: gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede},iduniversidad:${iduniversidad},gestion:${gestion}){ id,course_category_id,fase,codigo,nombre_compuesto} }`,
    })
    .then(({ data: { getProgramas } }) => {
      return getProgramas;
    })
    .catch((error) => error);
  res.map((p, i) => {
    p.text = `${i + 1}.- ${p.nombre_compuesto} [${p.codigo}]`;
  });
  return res;
};

export const getHeaders = () => {
  return [
    { text: 'Nombres', value: 'nombres' },
    // { text: 'Apellidos', value: 'apellidos' },
    // { text: 'Documento', value: 'num_doc' },

    // { text: 'TITULO ENTREGADO', value: 'titulo_entregado' },
    // { text: 'DOC. en DNA', value: 'doc_dna' },
    // { text: 'DOC. COMPLETA EN SEDE', value: 'doc_completa_sede' },
    // { text: 'DOC. INCOMPLETA EN SEDE', value: 'doc_incompleta_sede' },
    // { text: 'NO COMPLETO SU INSTRUMENTO DE TITULACION', value: 'no_completo_inst' },
    // { text: 'NO CONTESTA NO RESPONDE', value: 'no_contesta' },
  ];
};

export const getEstadosTitulacion = (vue) => {
  const res = vue.$apollo
    .query({
      query: gql`
        query {
          getEstadosTitulacion(estado: true) {
            id
            nombre
            color
            estado
          }
        }
      `,
    })
    .then(({ data: { getEstadosTitulacion } }) => {
      return getEstadosTitulacion;
    })
    .catch((error) => error);
  return res;
};

export const setEstadoTitulacion = (vue, insid, estadoid) => {
  const res = vue.$apollo
    .query({
      query: gql`mutation{cambioEstadoTitulacion(input:{inscripcion_id:${insid},nuevo_estado:${estadoid}}){ok,errors{message}}}`,
    })
    .then(({ data: { cambioEstadoTitulacion } }) => {
      return cambioEstadoTitulacion;
    })
    .catch((error) => error);
  return res;
};

export const setEstadoInscritoUniv = (vue, insid, estadobool) => {
  const res = vue.$apollo
    .query({
      query: gql`mutation{cambioInscritoUniversidad(input:{inscripcion_id:${insid},nuevo_estado:${estadobool}}){ok,errors{message}}}`,
    })
    .then(({ data: { cambioInscritoUniversidad } }) => {
      return cambioInscritoUniversidad;
    })
    .catch((error) => error);
  return res;
};


export const setEstadoIsModular = (vue, insid, estadobool) => {
  const res = vue.$apollo
    .query({
      query: gql`mutation{cambioIsModular(input:{inscripcion_id:${insid},nuevo_estado:${estadobool}}){ok,errors{message}}}`,
    })
    .then(({ data: { cambioIsModular } }) => {
      return cambioIsModular;
    })
    .catch((error) => error);
  return res;
};

export const getDatos = async (programa_id) => {
  let data;
  var config = {
    method: 'get',
    url: `${process.env.VUE_APP_API_REST}/api/v1/esam/inscripcion/reporte/estadotitulacion?programa_id=${programa_id}`,
    headers: {},
  };
  await xaxios.request(config)
    .then(function (response) {
      data = response.data.data;
    })
    .catch(function (error) {
      window.console.log(error);
    });

  const headers = data.cabezera.map((item) => ({
    text: item.nombre,
    value: item.nombre,
  }));
  headers.unshift(
    { text: 'Nombres', value: 'nombres', class: 'sticky-column' },
    { text: 'Primer Apellido', value: 'primer_apellido', class: 'sticky-column' },
    { text: 'Segundo Apellido', value: 'segundo_apellido', class: 'sticky-column' },
    { text: 'Numero Documento', value: 'numero_documento', class: 'sticky-column' },
    { text: 'Inscrito Universidad', value: 'inscrito_universidad' },
  );

  const totales = {};
  for (const item of data.data) {
    for (const header of headers) {
      const { value } = header;
      const valor = item[value];

      // Verificar si el valor es numérico y agregarlo al total correspondiente
      if (typeof valor === 'boolean') {
        if (!totales[value]) {
          totales[value] = 0;
        }
        let val = valor ? 1 : 0;
        totales[value] += val;
      }
    }
  }

  return { datos: data.data, totales: totales, headers: headers };
};


export const getDatosSedes = async (sede_id,gestion=null,universidad=null) => {

  let condiciones = [];

  if (sede_id) {
    condiciones.push(`sede_id=${sede_id}`);
  }
  if (gestion) {
    condiciones.push(`gestion=${gestion}`);
  }
  if (universidad){
    condiciones.push(`universidad_id=${universidad}`)
  }

  let query = "";
  if (condiciones.length > 0) {
    query = "?" + condiciones.join("&");
  }
  let data;
  var config = {
    method: 'get',
    url: `${process.env.VUE_APP_API_REST}/api/v1/esam/inscripcion/reporte/estadotitulacionSede`+query,
    headers: {},
  };
  await xaxios.request(config)
    .then(function (response) {
      data = response.data.data;
    })
    .catch(function (error) {
      window.console.log(error);
    });
  const headers = data.cabezera.map((item) => ({
    text: item.nombre,
    value: item.nombre,
  }));
  headers.unshift(
    { text: 'Nombre Programa', value: 'nombre_compuesto', class: 'sticky-column' },
    { text: 'Inscritos', value: 'total_inscripciones', class: 'sticky-column' },
    { text: 'Inscritos Universidad', value: 'total_inscritos_universidad', class: 'sticky-column' }, 
  );
  const totales = {};
  for (const item of data.data) {
    for (const header of headers) {
      const { value } = header;
      const valor = item[value];

      let numero = parseInt(valor);
      if (!isNaN(numero)) {
        if (!totales[value]) {
          totales[value] = 0;
        }        
        totales[value] += numero;
      } 
    }
  }

  return { datos: data.data, totales: totales, headers: headers };
};
